var _path, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLupa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.017 32.8608L46.4138 48M37.531 19.4684C37.531 29.1159 29.5771 36.9367 19.7655 36.9367C9.95389 36.9367 2 29.1159 2 19.4684C2 9.82085 9.95389 2 19.7655 2C29.5771 2 37.531 9.82085 37.531 19.4684Z",
    stroke: "white",
    strokeWidth: 3.17241,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.4495,
    y1: 13.1034,
    x2: 19.4495,
    y2: 25.7931,
    stroke: "white",
    strokeWidth: 3.17241,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.0979,
    y1: 19.4483,
    x2: 25.7876,
    y2: 19.4483,
    stroke: "white",
    strokeWidth: 3.17241,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupa);
export default __webpack_public_path__ + "static/media/lupa.280c13d0a4992cad587112f794bf67e5.svg";
export { ForwardRef as ReactComponent };